import React from "react";

import './Section7.css';
import logo from '../ecoindexhd.png'; // Adjust if different
import phoneImg from './mockup.png'; // Optional, if using phone image
import { FaInstagram, FaXTwitter, FaLinkedinIn } from 'react-icons/fa6';


const Section7 = () => {

  
    

    return (
      <div className="ecoindex-section7">
        <div className="ecoindex-s7-left">
          <img src={phoneImg} alt="App Preview" className="ecoindex-s7-phone" />
        </div>
  
        <div className="ecoindex-s7-middle">
          <div className="ecoindex-s7-links">
            <a href="/aboutecoindex" className="link" target="_blank">
                  About Us
                </a>
          <a href="/Resources" className="link" target="_blank">
                  Resources
                </a>
            
           
          </div>
          <div className="ecoindex-s7-contact">
            <p><span className="ecoindex-s7-bold">E-Mail:</span>  📧 <a href="mailto:connect@ecoindex.ai"> connect@ecoindex.ai</a></p>
            <p><span className="ecoindex-s7-bold">Address:</span> Sector 62, Noida, Uttar Pradesh</p>
          </div>
          <div className="ecoindex-s7-policies">
            <a
                  href="/terms_and_conditions"
                  className="link"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Terms of Service
                </a>
            <span></span>
           <a
                             href="/privacy_policy"
                             className="link"
                             target="_blank"
                             rel="noopener noreferrer"
                           >
                             Privacy Policy
                           </a>
            <span></span>
           
          </div>
          <p className="ecoindex-s7-copy">© 2025 EcoIndex. All rights reserved.</p>
        </div>
  
        <div className="ecoindex-s7-right">
          <img src={logo} alt="EcoIndex Logo" className="ecoindex-s7-logo" />
          <div className="ecoindex-s7-input-wrap">
            <input type="text" placeholder="Enter your email id" />
            <span className="ecoindex-s7-arrow">↗</span>
          </div>
        
<div className="ecoindex-s7-icons">
  <a href="https://www.instagram.com/ecoindex_ai/" target="_blank" rel="noopener noreferrer">
    <FaInstagram />
  </a>
  <a href="https://x.com/Ecoindex_ai" target="_blank" rel="noopener noreferrer">
    <FaXTwitter />
  </a>
  <a href="https://www.linkedin.com/company/ecoindex" target="_blank" rel="noopener noreferrer">
    <FaLinkedinIn />
  </a>
</div>
          <img
            src="https://upload.wikimedia.org/wikipedia/commons/7/78/Google_Play_Store_badge_EN.svg"
            alt="Google Play"
            className="ecoindex-s7-playstore"
          />
        </div>
         
      </div>
    );
  };
  
  export default Section7;